<template>
  <div class="infoBox">
    <h1>{{ cTitle }}</h1>
    <ul>
      <li v-for="(item, index) in cWords" :key="index">
        <i><img :src="iconBg[index]" alt="" /> </i>
        <a :href="item.link">{{ item.word }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "v-info-box",
  components: {},
  props: {
    cTitle: {
      type: String,
      default: "标题",
      requrie: true,
    },
    cWords: {
      type: Array,
      default() {
        return [{ word: "", link: "" }];
      },
    },
  },
  data() {
    return {
      iconBg: [
        require("../assets/img/infoBox_icon1.png"),
        require("../assets/img/infoBox_icon2.png"),
        require("../assets/img/infoBox_icon3.png"),
        require("../assets/img/infoBox_icon4.png"),
        require("../assets/img/infoBox_icon5.png"),
        require("../assets/img/infoBox_icon6.png"),
      ],
    };
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>

<style scoped>
.infoBox {
  width: 330px;
  height: 140px;
  float: left;
  border: 1px solid rgb(16, 115, 183);
  overflow: hidden;
  text-align: center;
  border-radius: 10px;
  color: rgb(63, 115, 173);
}

.infoBox h1 {
  margin-top: 10px;
  margin-bottom: 0;
  padding-bottom: 0;
}

.infoBox ul {
  width: 100%;
}
.infoBox ul li {
  float: left;
  width: 40%;
}
.infoBox ul li a {
  display: inline-block;
  color: rgb(16, 115, 183);
  width: 70px;
  text-align: left;
  margin-left: 5px;
}
.infoBox ul li i {
  display: inline-block;
  width: 14px;
  height: 14px;
  color: #ffffff;
}
.infoBox ul li i img {
  width: 100%;
  height: 100%;
}
</style>